/** Path of the identity providers list page. */
export const IDENTITY_PROVIDERS_PATH =
  "/settings/access-control/identity-providers";

/**
 * Tooltip copy for the provider management actions, which are disabled without
 * system edit permission.
 */
export const MANAGE_PROVIDERS_PERMISSION_MESSAGE =
  "You need system edit permission to add an identity provider";
